import { computed, Injectable, signal } from '@angular/core';

/** Producto que disparó el bloqueo, con su umbral efectivo ya resuelto. */
export interface EarlyAccessBlockedContext {
  productId: number;
  productName: string;
  /** Umbral efectivo (R8). `0` significa «solo requiere sesión». */
  threshold: number;
}

/**
 * Estado global del diálogo de bloqueo de Acceso VIP (R2), análogo a
 * `PerronPointsModalService`: el diálogo se monta una única vez en `app.ts` y
 * cualquier superficie —en la práctica, `CartService.addLine`— solo llama
 * `open()`.
 *
 * No bloquea el scroll del body aquí (a diferencia de otros modales del repo):
 * lo hace el componente, que además RESTAURA el valor previo, porque este
 * diálogo puede abrirse sobre el drawer del carrito o sobre otro modal que ya
 * tenía el scroll bloqueado.
 */
@Injectable({ providedIn: 'root' })
export class EarlyAccessBlockedDialogService {
  private readonly _context = signal<EarlyAccessBlockedContext | null>(null);

  readonly context = this._context.asReadonly();
  readonly isOpen = computed(() => this._context() !== null);

  open(context: EarlyAccessBlockedContext): void {
    this._context.set(context);
  }

  close(): void {
    this._context.set(null);
  }
}
